import { screenToStudio, studioToScreen } from "@logic/lib/design"
import { useRecoilTransaction_UNSTABLE } from "recoil"

import { invertPoint } from "~/containers/LegacyDesigner/state/scroll"

import type { TransactionOperation } from "."
import { changePan } from "./changePan"
import { centerOfImageState } from "../../imageElements"
import { zoomState } from "../../view"

export const zoomToImageCenterPoint: TransactionOperation<
  (zoom: number) => number
> = (transactors, transformZoom) => {
  const { set, get } = transactors
  const zoom = get(zoomState)
  const newZoom = transformZoom(zoom)
  const centerPoint = get(centerOfImageState)
  const centerPointInStudio = screenToStudio.point(centerPoint, zoom)
  const newZoomedCenterPointInStudio = screenToStudio.point(centerPoint, newZoom)
  const centerPointChange = {
    x: newZoomedCenterPointInStudio.x - centerPointInStudio.x,
    y: newZoomedCenterPointInStudio.y - centerPointInStudio.y,
  }
  set(zoomState, newZoom)
  changePan(
    transactors,
    studioToScreen.point(invertPoint(centerPointChange), newZoom),
  )
}

export type ZoomToCenterPoint = (transformZoom: (zoom: number) => number) => void

export const useZoomToImageCenterPoint = (): ZoomToCenterPoint =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => (transformZoom) =>
      zoomToImageCenterPoint(transactors, transformZoom),
  )
